import React from "react";
import { useCallback, useContext, useEffect, useState } from "react";

import { Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";

import Card from "../../../../components/cards/Card";
import { Margin } from "../../../financeiro/nfe/styles/Emissao";
import {
  StyledChip,
  ProcessDiv,
  FailedDiv,
  SuccessDiv,
  TableChip,
  Pendingdiv,
  CanceledDiv,
  DemonstrativoIcon,
} from "../styles/TabelaFaturamento";
import TableDefault from "../../../../components/grid/TableDefault";
import { FaturamentoContratoContext } from "../contexts/FaturamentoContratoContext";
import MaskService from "../../../../utils/mask/maskService";
import Btn from "../../../../components/buttons/Btn";
import BoletoIcon from "../../../../assets/icons/BoletoIcon";
import EmailIcon from "../../../../assets/icons/EmailIcon";
import NFSeIcon from "../../../../assets/icons/NFSeIcon";
import useGerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import { ModalLog } from "../../../../patterns/modals/modallog/ModalLog";
import { notify } from "../../../../utils/notify";
import moment from "moment";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

export default function TabelaFaturamentoCard() {
  const {
    sendInvoice,
    calculateInvoice,
    simulatedBillingQyonBank,
    handleSearchTitles,
    findLogsInvoiceByIdCr,
  } = useGerenciamentoContratoController();

  const {
    itensTable,
    selectedItem,
    setSelectedItem,
    pagePropDefault,
    setPagePropDefault,
    setBillingStatus,
  } = useContext(FaturamentoContratoContext);

  const [disableButton, setDisableButton] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);

  const handleUseEffect = useCallback(async () => {
    await calculateInvoice();
    await simulatedBillingQyonBank();
    const verifyItem = selectedItem.some((item) => {
      return item.status_geral === "processando";
    });
    setDisableButton(verifyItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculateInvoice, simulatedBillingQyonBank]);

  useEffect(() => {
    handleUseEffect();
  }, [selectedItem, handleUseEffect]);

  const [modalLog, setModalLog] = useState(false);
  const [contentLog, setContentLog] = useState(null);

  const jsonTitleStatus = (key) => {
    return {
      processando: `${key} em Processamento`,
      concluido: `Sucesso ao gerar ${key}`,
      falha: `Falha ao gerar ${key}`,
      cancelada: `NFSe cancelada`,
      "": key === "DemonstrativoFinanceiro" ? "Demonstrativo Financeiro" : key,
    };
  };

  const jsonStatusList = {
    faturar: <TableChip bgcolor="blue" textcolor="white" label="À Faturar" />,
    processando: (
      <TableChip bgcolor="orange" textcolor="white" label="Processando" />
    ),
    falha: <TableChip bgcolor="red" textcolor="white" label="Falha" />,
    faturado: <TableChip bgcolor="green" textcolor="white" label="Faturado" />,
  };

  const jsonIconsProcess = {
    NFSe: <NFSeIcon />,
    Boleto: <BoletoIcon />,
    DemonstrativoFinanceiro: <DemonstrativoIcon />,
    Email: <EmailIcon />,
  };

  const handleProcessStyled = (key) => {
    return {
      processando: <ProcessDiv>{jsonIconsProcess[key]}</ProcessDiv>,
      falha: <FailedDiv>{jsonIconsProcess[key]}</FailedDiv>,
      concluido: <SuccessDiv>{jsonIconsProcess[key]}</SuccessDiv>,
      cancelada: <CanceledDiv>{jsonIconsProcess[key]}</CanceledDiv>,
      "": <Pendingdiv>{jsonIconsProcess[key]}</Pendingdiv>,
    };
  };

  const handleProcess = (status, key) => {
    const normalizedStatus =
      status != null && Object.prototype.hasOwnProperty.call(
        handleProcessStyled(key),
        status
      )
        ? status
        : "";
    
    const content = handleProcessStyled(key)[normalizedStatus];
    const title =
      jsonTitleStatus(key)[normalizedStatus] ??
      jsonTitleStatus(key)[""] ??
      key;

    if (!content) return null;

    return (
      <Tooltip title={title}>
        <span>{content}</span>
      </Tooltip>
    );
  };

  const openLog = async (value) => {
    if (value?.queuelog.length === 0)
      return notify("Título sem registros de alteração", true, "warning");

    var logs = await findLogsInvoiceByIdCr(value?.id);
    if (logs?.data) {
      logs?.data?.queuelog.sort((a, b) => (a.id > b.id ? 1 : -1));
      setContentLog(logs?.data?.queuelog);
      setModalLog(true);
    }
  };

  const columns = [
    {
      label: "",
      format: (value) => {
        return (
          <>
            <Tooltip title="Visualizar">
              <IconButton size="small" onClick={() => openLog(value)}>
                <VisibilityOutlinedIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      align: "left",
      disablePadding: true,
    },

    {
      label: "Status",
      align: "left",
      format: (value) =>
        jsonStatusList[value?.status_geral] ?? value?.status_geral ?? "",
      disablePadding: false,
    },
    {
      label: "Processos",
      align: "left",
      format: (value) => {
        return (
          <>
            {handleProcess(value?.status_nfse ?? "", "NFSe")}
            {handleProcess(value?.status_boleto ?? "", "Boleto")}
            {handleProcess(
              value?.status_demonstrativo_financeiro ?? "",
              "DemonstrativoFinanceiro"
            )}
            {handleProcess(value?.status_email ?? "", "Email")}
          </>
        );
      },
      disablePadding: true,
    },
    {
      label: "Cliente",
      id: "clienterazao",
      align: "left",
      format: (value) => {
        return (value.clienterazao = (value?.cliente?.razao || "").substring(
          0,
          60
        ));
      },
      disablePadding: true,
    },
    {
      label: "Proposta",
      id: "contratoproposta",
      align: "left",
      format: (value) => {
        return (value.contratoproposta = value?.contrato?.proposta ?? null);
      },
      disablePadding: true,
    },
    {
      label: "Vencimento",
      id: "datavencto",
      align: "left",
      format: (value) => value?.datavencto.split("-").reverse().join("/"),
      disablePadding: true,
    },
    {
      label: "Modalidade",
      id: "contratomodalidade",
      align: "left",
      format: (value) => {
        return (value.contratomodalidade =
          value?.contrato?.modalidade === "R" ? "REC" : "AVUL");
      },
      disablePadding: true,
    },
    {
      label: "Valor à Receber",
      id: "valordocto",
      align: "center",
      format: (value) =>
        `R$ ${
          value?.valordocto
            ? MaskService.toMask("decimal", value?.valordocto)
            : "00,00"
        } `,
      disablePadding: true,
    },
    {
      label: "Vigência",
      id: "vigencia_renovacao",
      align: "left",
      format: (value) => value?.contrato?.vigencia_renovacao || "-",
      disablePadding: true,
    },
    {
      label: "Dt. Último Reajuste",
      id: "dataultimoreajuste",
      align: "left",
      format: (value) =>
        value?.contrato?.dataultimoreajuste
          ? moment(value?.contrato?.dataultimoreajuste, "YYYY-MM-DD").format(
              "DD/MM/YYYY"
            )
          : "-",
      disablePadding: true,
    },
  ];

  return (
    <>
      {modalLog && (
        <ModalLog
          open={modalLog}
          content={contentLog}
          setContent={setContentLog}
          setOpen={setModalLog}
        />
      )}
      <Container maxWidth="xl">
        <Margin top={20}>
          <Card>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={2}>
                <StyledChip
                  bgcolor="lightblue"
                  textcolor="white"
                  label="Todos"
                  onClick={() => {
                    setBillingStatus({ label: "Todos", value: "all" });
                    handleSearchTitles("all");
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <StyledChip
                  bgcolor="blue"
                  textcolor="white"
                  label="À Faturar"
                  onClick={() => {
                    setBillingStatus({
                      label: "A Faturar",
                      value: "invoice",
                    });
                    handleSearchTitles("invoice");
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <StyledChip
                  textcolor="white"
                  bgcolor="orange"
                  label="Processando"
                  onClick={() => {
                    setBillingStatus({
                      label: "Em Processamento",
                      value: "processing",
                    });
                    handleSearchTitles("processing");
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <StyledChip
                  textcolor="white"
                  label="Falha"
                  bgcolor="red"
                  onClick={() => {
                    setBillingStatus({ label: "Falha", value: "failed" });
                    handleSearchTitles("failed");
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <StyledChip
                  textcolor="white"
                  label="Faturado"
                  bgcolor="green"
                  onClick={() => {
                    setBillingStatus({ label: "Faturado", value: "billed" });
                    handleSearchTitles("billed");
                  }}
                />
              </Grid>

              <Grid item container xs={2}>
                <Tooltip
                  label={
                    queryParams.empresa_cnpj?.endsWith("_democ")
                      ? "Operação não permitida em ambiente de treinamento"
                      : ""
                  }
                  placement="top"
                >
                  <span>
                    <Btn
                      label="FATURAR"
                      onClick={sendInvoice}
                      full="true"
                      disabled={disableButton}
                    />
                  </span>
                </Tooltip>
              </Grid>
            </Grid>

            <Margin top={10} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableDefault
                  selectable={true}
                  tableTitle=""
                  columns={columns}
                  values={itensTable}
                  disablePaddingCheckbox
                  paddingNoneRows
                  smallFont
                  selected={selectedItem}
                  setSelected={setSelectedItem}
                  className="GerenciamentoContrato"
                  selectedByRow={false}
                  allChecked={true}
                  pageProp={pagePropDefault}
                  setPageProp={setPagePropDefault}
                />
              </Grid>
            </Grid>
          </Card>
        </Margin>
      </Container>
    </>
  );
}
